module.exports = __webpack_public_path__ + "img/BGTOW.b28358f8.png";